/**
 * Decode HTML entities in a string
 * @param {string} text The text containing HTML entities
 * @return {string} Text with HTML entities decoded
 */
export function decodeHtmlEntities(text) {
  if (!text) return text;
  
  const textArea = document.createElement('textarea');
  textArea.innerHTML = text;
  return textArea.value;
}

/**
 * Convert Vimeo URLs in HTML content to embedded players
 * @param {string} html The HTML content
 * @return {string} HTML with Vimeo URLs converted to embeds
 */
export function convertVimeoUrlsToEmbeds(html) {
  if (!html) return html;

  // Match Vimeo URLs (including those in anchor tags or plain text)
  const vimeoRegex = /(?:<a[^>]*>)?\s*(https?:\/\/(?:www\.)?vimeo\.com\/([0-9]+)[^\s<]*)\s*(?:<\/a>)?/gi;

  return html.replace(vimeoRegex, (match, url, videoId) => {
    return `<div class="vimeo-embed-wrapper"><iframe src="https://player.vimeo.com/video/${videoId}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div>`;
  });
}
